import React, { useState } from 'react';
import { useSpring, animated } from 'react-spring';
import '../styles.css';
import { useDispatch } from 'react-redux';
import { GOTO_PAGE } from '../../HOME/REDUX/actions';
import BackButton from '../COMPONENTS/BackButton';
import { GradientBackground } from '../COMPONENTS/Background';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import _ from 'lodash';
import { GAME_PAGE } from '../../HOME/const';
import * as f from '../logic';
import { SELECT_SIZE } from '../REDUX/actions';
import StarIcon from '../../HOME/SVG/StarIcon';

const SizePage = () => {
  const dispatch = useDispatch();
  const [size, setSize] = useState(0);

  const handleSize = () => {
    dispatch({ type: SELECT_SIZE, size });
    dispatch({ type: GOTO_PAGE, payload: { page: GAME_PAGE } });
  };

  const pulseString = useSpring({
    to: { transform: `scale(${size ? 0.75 : 1})` },
    onRest: () => size && handleSize(),
    config: { duration: 200 },
  });

  const sizes = ['X-Small', 'Small', 'Medium', 'Large', 'X-Large'];
  const colors = ['#337BB1', '#33B169', '#B16933', '#A833B1', '#B1333C'];
  const starStyle = { gridArea: '1/1', width: '60px', justifySelf: 'center' };

  return (
    <div className="page-root">
      <div className="ms-logo-title">{f.renderTitle('Size', 'mt-title pt-title')}</div>
      <div className="pt-page" style={{ backgroundImage: GradientBackground }}>
        {_.map([3, 4, 5, 6, 7], op => {
          const width = 10 + op * 6;
          const style = op === size ? pulseString : {};
          return (
            <animated.div key={op} className="pt-start-option pt-option" style={style} onClick={() => setSize(op)}>
              <StarIcon style={starStyle} width={width} strokeWidth={4} rounded color={colors[op - 3]} />
              {f.renderTitle(sizes[op - 3], 'mt-tilte pt-title pt-text-option')}
            </animated.div>
          );
        })}
        <BackButton />
        <HomeButton />
      </div>
    </div>
  );
};

export default SizePage;
